module.exports = __webpack_public_path__ + "img/thumb_21.b476efec.jpg";